import {Directive, ElementRef, Input, SimpleChanges, OnChanges} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Directive({
    selector: '[data-pattern]',
    standalone: false
})
export class DataPatternDirective implements OnChanges {

    @Input() data: any;
    @Input() pattern: string;

    constructor(private el: ElementRef,
                private translateSvc: TranslateService,) { }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes['pattern'] && this.pattern) {
            this.translate();
            this.setDataOnPattern(0);
            this.el.nativeElement.innerHTML = this.pattern;
        }
    }

    setDataOnPattern(currentIndex) {
        let start = this.pattern.indexOf('{', currentIndex)
        if (start == -1) return;
        currentIndex++;
        let end = this.pattern.indexOf('}', currentIndex);
        if (end == -1) return;
        let prop = this.pattern.substring(start + 1, end);
        this.pattern = this.pattern.replace(`{${prop}}`, this.data[prop])
        // this.setDataOnPattern(end++);
        if(this.data[prop])
            this.setDataOnPattern( this.data[prop].length + 1);
        return;
    }

    translate() {
        let m, rx = /(^|\})(.*?)(\{|$)/g, text, translatedText;
        while ((m=rx.exec(this.pattern)) !== null) {
            if(!m[2]) continue;
            text = m[2].trim();
            translatedText = this.translateSvc.instant(text)
            this.pattern = this.pattern.replace(text, translatedText)
        }
    }
}
